import React, { createContext, useContext, useState, ReactNode } from 'react';

type ModalType = 'trial' | 'legal' | 'insulin-insights' | 'save-progress' | 'blood-trial' | 'blood-legal';

interface ModalContextType {
  openModal: (modal: ModalType) => void;
  closeModal: () => void;
  isModalOpen: boolean;
  activeModal: ModalType | null;
  isOpen: (modal: ModalType) => boolean;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: ReactNode }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState<ModalType | null>(null);

  const openModal = (modal: ModalType) => {
    setActiveModal(modal);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveModal(null);
  };

  const isOpen = (modal: ModalType) => isModalOpen && activeModal === modal;

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isModalOpen, activeModal, isOpen }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}
